// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-btn:hover{cursor:pointer}.title-btn circle{fill:var(--gray13)}.title-btn:hover circle{fill:var(--gray15)}\n", ""]);
